import Draggable, {} from 'react-draggable';
import styles from "./QuickSetupModal.module.css"
import {useContext, useEffect, useLayoutEffect, useRef, useState} from "react";
import {Button} from "@base-ui/react/button";
import {YuJaTooltip} from "./standardization/YuJaTooltip";
import {
    INTEGRATION_BUTTON,
    INTEGRATION_TYPES,
    MENU_LIST,
    YUJA_SUPPORT_LINK
} from "../utils/constants";
import {YuJaGlobalState} from "../utils/LoadingContext";
import {checkAPICompleted, checkLTICompletedNew, notifyInfo} from "../utils/helpers";
import {useLocalStorageNew} from "../hooks/useLocalStorageNew";
import {useHistory, useLocation} from "react-router-dom";
import {ReactComponent as QUICK_SETUP} from "../images/quick_setup_icon.svg";
import { useTranslation } from "react-i18next";

export default function QuickSetupModal({}) {
    const { t } = useTranslation();
    const {
        isQuickSetupModalDismissed,
        setIsQuickSetupModalDismissed,
        selectedIntegrationBtn,
        setSelectedIntegrationBtn,
        globalHostResource
    } = useContext(YuJaGlobalState);

    const history = useHistory();
    const location = useLocation();
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [minimized, setMinimized] = useState(false);
    const containerFullRef = useRef();
    const wrapperFullRef = useRef();

    const containerMinimizedRef = useRef();
    const wrapperMinimizedRef = useRef();

    const [isLTICompleted, setIsLTICompleted] = useState(false);
    const [isAPICompleted, setIsAPICompleted] = useState(false);



    useLayoutEffect(() => {
        const handleBounds = () => {
            const activeContainer = minimized ? containerMinimizedRef.current : containerFullRef.current;
            const activeWrapper = minimized ? wrapperMinimizedRef.current : wrapperFullRef.current;

            if (!activeContainer || !activeWrapper) return;

            const containerWidth = activeContainer.offsetWidth;
            const containerHeight = activeContainer.offsetHeight;
            const wrapperWidth = activeWrapper.offsetWidth;
            const wrapperHeight = activeWrapper.offsetHeight;

            const minX = wrapperWidth - containerWidth;
            const minY = wrapperHeight - containerHeight;

            setPosition((pos) => {
                const newX = Math.min(Math.max(minX, pos.x), 0);
                const newY = Math.min(Math.max(minY, pos.y), 0);

                return { x: newX, y: newY };
            });
        };

        window.addEventListener("resize", handleBounds);
        handleBounds();

        return () => window.removeEventListener("resize", handleBounds);
    }, [minimized]);

    useEffect(() => {
        setMinimized(false);
        if (!isQuickSetupModalDismissed) {
            if (!isLTICompleted) {
                setSelectedIntegrationBtn(INTEGRATION_BUTTON.LTI_1_DOT_3.key);
            } else if (!isAPICompleted) {
                setSelectedIntegrationBtn(INTEGRATION_BUTTON.API.key);
            } else if (!selectedIntegrationBtn) {
                setSelectedIntegrationBtn(INTEGRATION_BUTTON.LTI_1_DOT_3.key);
            }
        }
    }, [isQuickSetupModalDismissed]);


    useEffect(() => {
        let LTICompleted = checkAnyLTIIsCompleted();
        setIsLTICompleted(LTICompleted);
        let APICompleted = checkAPICompleted(globalHostResource);
        setIsAPICompleted(APICompleted);
    }, [globalHostResource]);



    const checkAnyLTIIsCompleted = () => {
        if (checkLTICompletedNew(globalHostResource, INTEGRATION_TYPES.CANVAS)) {
            return true;
        }
        if (checkLTICompletedNew(globalHostResource, INTEGRATION_TYPES.BLACKBOARD)) {
            return true;
        }
        if (checkLTICompletedNew(globalHostResource, INTEGRATION_TYPES.MOODLE)) {
            return true;
        }
        if (checkLTICompletedNew(globalHostResource, INTEGRATION_TYPES.D2L)) {
            return true;
        }

        return false;
    }






    if (isQuickSetupModalDismissed) {
        return <></>;
    }

    return (
        <div className={styles.guidContainer}>
            <div ref={containerFullRef} className={styles.guideWrapperFull}>
                <Draggable
                    nodeRef={wrapperFullRef}
                    bounds={"parent"}
                    position={position}
                    handle={`.${styles.guideFullHeader}`}
                    onDrag={(_, data) => setPosition({x: data.x, y: data.y})}
                >
                    <div
                        ref={wrapperFullRef}
                        className={`${styles.guideFull} ${!minimized ? styles.guideFullOpaque : ""}`}
                    >
                        <div className={styles.guideFullHeader}>
                            <p className={`${styles.guideFullTitle} ${styles.text}`}>
                                {t("integration.quickSetupGuide")}
                            </p>
                            <div className={styles.guidFullButtons}>
                                <YuJaTooltip text={t("common.minimize")} placement={"top"}>
                                    <Button onClick={() => setMinimized(true)}>
                                        <MinimizeIcon/>
                                    </Button>
                                </YuJaTooltip>

                                <YuJaTooltip text={t("common.close")} placement={"top"}>
                                    <Button
                                        onClick={() => {
                                            setIsQuickSetupModalDismissed(true);
                                            notifyInfo(t("onboarding.quickSetupGuideLocationInfo"));
                                        }}
                                    >
                                        <CloseIcon/>
                                    </Button>
                                </YuJaTooltip>
                            </div>
                        </div>

                        <div className={styles.guideFullBody}>
                            <p className={styles.text}>
                                {t("integration.quickSetupModalDescription")}
                            </p>
                            <div className={styles.guideFullIntegrations}>
                                <Button
                                    className={`
                                        ${styles.integrationButton} 
                                        ${selectedIntegrationBtn === INTEGRATION_BUTTON.LTI_1_DOT_3.key
                                        ? styles.integrationButtonSelected
                                        : ""
                                    }
                                    `}
                                    onClick={() => {
                                        setSelectedIntegrationBtn(INTEGRATION_BUTTON.LTI_1_DOT_3.key);
                                        if (location.pathname !== MENU_LIST.INTEGRATIONS.path) {
                                            history.push(MENU_LIST.INTEGRATIONS.path);
                                        }
                                    }}
                                >
                                    {INTEGRATION_BUTTON.LTI_1_DOT_3.label}
                                    {isLTICompleted && <CompletedIcon/>}
                                    {!isLTICompleted && <InCompletedIcon/>}
                                </Button>

                                <Button
                                    className={`
                                        ${styles.integrationButton} 
                                        ${selectedIntegrationBtn === INTEGRATION_BUTTON.API.key
                                        ? styles.integrationButtonSelected
                                        : ""
                                    }
                                    `}
                                    onClick={() => {
                                        setSelectedIntegrationBtn(INTEGRATION_BUTTON.API.key);
                                        if (location.pathname !== MENU_LIST.INTEGRATIONS.path) {
                                            history.push(MENU_LIST.INTEGRATIONS.path);
                                        }
                                    }}
                                >
                                    {INTEGRATION_BUTTON.API.label}
                                    {isAPICompleted && <CompletedIcon/>}
                                    {!isAPICompleted && <InCompletedIcon/>}
                                </Button>
                            </div>
                            <div style={{flex: 1, minHeight: 0}}/>
                            <div className={styles.guideFullFoot}>
                                <InfoIcon/>
                                <a
                                    className={styles.link}
                                    href={YUJA_SUPPORT_LINK}
                                    target={"_blank"}
                                    rel={"noreferrer"}
                                >
                                    {t("institution.yujaHelpCenter")}
                                </a>
                            </div>
                        </div>

                    </div>
                </Draggable>
            </div>


            <div ref={containerMinimizedRef} className={styles.guideWrapperMinimized}>
                <Draggable
                    nodeRef={wrapperMinimizedRef}
                    bounds="parent"
                    position={position}
                    onDrag={(_, data) => setPosition({x: data.x, y: data.y})}
                >
                    <div
                        ref={wrapperMinimizedRef}
                        className={`${styles.guideMinimized} ${minimized ? styles.guideMinimizedOpaque : ""}`}
                    >
                        <div className={styles.guideMinimizedHandle}>
                            <QUICK_SETUP/>
                            <p className={styles.text} style={{fontSize: 16, color: "#FFF", fontWeight: "600"}}>
                                {t("integration.setupGuide")}
                            </p>
                        </div>
                        <div className={styles.guideMinimizedButtons}>
                            <YuJaTooltip text={t("common.expand")} placement={"top"}>
                                <Button className={styles.guideMinimizedButton} onClick={() => setMinimized(false)}>
                                    <ExpandIcon style={{color: "#FFF"}}/>
                                </Button>
                            </YuJaTooltip>

                            <YuJaTooltip text={t("common.close")} placement={"top"}>
                                <Button
                                    className={styles.guideMinimizedButton}
                                    onClick={() => {
                                        setIsQuickSetupModalDismissed(true);
                                        notifyInfo(t("onboarding.quickSetupGuideLocationInfo"));
                                    }}
                                >
                                    <CloseIcon style={{color: "#FFF", width: 20, height: 20}}/>
                                </Button>
                            </YuJaTooltip>
                        </div>
                    </div>
                </Draggable>
            </div>
        </div>

    );
}


function MinimizeIcon(props) {
    return (
        <svg role="presentation" width="20" height="20" viewBox="0 0 24 24" fill="none"
             xmlns="http://www.w3.org/2000/svg" {...props}>
            <g>
                <path d="M13.5 6V10.5H18" stroke="#6f6f6f" strokeWidth="1.5" strokeLinecap="round"
                      strokeLinejoin="round"></path>
                <path d="M19.5 4.5L13.5 10.5" stroke="#6f6f6f" strokeWidth="1.5" strokeLinecap="round"
                      strokeLinejoin="round"></path>
                <path d="M6 13.5H10.5V18" stroke="#6f6f6f" strokeWidth="1.5" strokeLinecap="round"
                      strokeLinejoin="round"></path>
                <path d="M4.5 19.5L10.5 13.5" stroke="#6f6f6f" strokeWidth="1.5" strokeLinecap="round"
                      strokeLinejoin="round"></path>
            </g>
        </svg>
    );
}


function CloseIcon(props) {
    return (
        <svg width="24" height="24" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g transform="translate(3, 2)">
                <path d="M17.9688 5.53125L5.03125 18.4688" stroke="#6f6f6f" strokeWidth="1.4375"
                      strokeLinecap="round" strokeLinejoin="round"></path>
                <path d="M17.9688 18.4688L5.03125 5.53125" stroke="#6f6f6f" strokeWidth="1.4375"
                      strokeLinecap="round" strokeLinejoin="round"></path>
            </g>
        </svg>
    );
}

function ExpandIcon(props) {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g >
                <path d="M11.8125 3.375H14.625V6.1875" stroke="white" strokeWidth="1.5" strokeLinecap="round"
                      strokeLinejoin="round"/>
                <path d="M6.1875 14.625H3.375V11.8125" stroke="white" strokeWidth="1.5" strokeLinecap="round"
                      strokeLinejoin="round"/>
                <path d="M14.625 11.8125V14.625H11.8125" stroke="white" strokeWidth="1.5" strokeLinecap="round"
                      strokeLinejoin="round"/>
                <path d="M3.375 6.1875V3.375H6.1875" stroke="white" strokeWidth="1.5" strokeLinecap="round"
                      strokeLinejoin="round"/>
            </g>
        </svg>

    );
}

function InfoIcon(props) {
    return (
        <svg width="24" height="24" viewBox="0 0 26 26" fill="#42296e" xmlns="http://www.w3.org/2000/svg"
             role="presentation" {...props}>
            <path
                d="M13 0C10.4288 0 7.91543 0.762437 5.77759 2.1909C3.63975 3.61935 1.97351 5.64968 0.989572 8.02512C0.0056327 10.4006 -0.251811 13.0144 0.249797 15.5362C0.751405 18.0579 1.98953 20.3743 3.80762 22.1924C5.6257 24.0105 7.94208 25.2486 10.4638 25.7502C12.9856 26.2518 15.5995 25.9944 17.9749 25.0104C20.3503 24.0265 22.3807 22.3603 23.8091 20.2224C25.2376 18.0846 26 15.5712 26 13C25.9964 9.5533 24.6256 6.24882 22.1884 3.81163C19.7512 1.37445 16.4467 0.00363977 13 0ZM13 24C10.8244 24 8.69767 23.3549 6.88873 22.1462C5.07979 20.9375 3.66989 19.2195 2.83733 17.2095C2.00477 15.1995 1.78693 12.9878 2.21137 10.854C2.63581 8.72022 3.68345 6.7602 5.22183 5.22183C6.76021 3.68345 8.72022 2.6358 10.854 2.21136C12.9878 1.78692 15.1995 2.00476 17.2095 2.83733C19.2195 3.66989 20.9375 5.07979 22.1462 6.88873C23.3549 8.69767 24 10.8244 24 13C23.9967 15.9164 22.8367 18.7123 20.7745 20.7745C18.7123 22.8367 15.9164 23.9967 13 24ZM15 19C15 19.2652 14.8946 19.5196 14.7071 19.7071C14.5196 19.8946 14.2652 20 14 20C13.4696 20 12.9609 19.7893 12.5858 19.4142C12.2107 19.0391 12 18.5304 12 18V13C11.7348 13 11.4804 12.8946 11.2929 12.7071C11.1054 12.5196 11 12.2652 11 12C11 11.7348 11.1054 11.4804 11.2929 11.2929C11.4804 11.1054 11.7348 11 12 11C12.5304 11 13.0391 11.2107 13.4142 11.5858C13.7893 11.9609 14 12.4696 14 13V18C14.2652 18 14.5196 18.1054 14.7071 18.2929C14.8946 18.4804 15 18.7348 15 19ZM11 7.5C11 7.20333 11.088 6.91332 11.2528 6.66665C11.4176 6.41997 11.6519 6.22771 11.926 6.11418C12.2001 6.00065 12.5017 5.97094 12.7926 6.02882C13.0836 6.0867 13.3509 6.22956 13.5607 6.43934C13.7704 6.64912 13.9133 6.91639 13.9712 7.20736C14.0291 7.49834 13.9994 7.79994 13.8858 8.07403C13.7723 8.34811 13.58 8.58238 13.3334 8.7472C13.0867 8.91203 12.7967 9 12.5 9C12.1022 9 11.7206 8.84196 11.4393 8.56066C11.158 8.27936 11 7.89782 11 7.5Z"></path>
        </svg>
    );
}


function InCompletedIcon(props) {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect x="0.75" y="0.75" width="16.5" height="16.5" rx="8.25" fill="#F7F7F7"></rect>
            <rect x="0.75" y="0.75" width="16.5" height="16.5" rx="8.25" stroke="#8E8E8E" strokeWidth="1.5"
                  strokeLinejoin="round" strokeDasharray="3 3"></rect>
        </svg>
    );
}


function CompletedIcon(props) {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect width="18" height="18" rx="9" fill="#008400"></rect>
            <path d="M5.21875 9.57812L7.5625 11.9219L13.0312 6.45312" stroke="white" strokeWidth="1.5"
                  strokeLinecap="round" strokeLinejoin="round"></path>
        </svg>
    );
}